export default {
    xxxxl: 34,
    xxxl: 28,
    xxl: 24,
    xl: 20,
    l: 18,
    m: 16,
    s: 14,
    xs: 12,
    xxs: 10,
}